import {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {getTagNames} from '../../api/EcaServices';
import {ITag} from '../../components/pages/field-management/custom-field/DraggableTag';
import {RootState} from '../../redux/store';

interface State {
  isLoading: boolean;
  isFailedToLoadContent: boolean;
}

export const useGetTagNames = () => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const [state, setState] = useState<State>({
    isLoading: false,
    isFailedToLoadContent: false,
  });

  const getAllTagNames = useCallback(
    async (fieldId: string) => {
      setState({isLoading: true, isFailedToLoadContent: false});

      try {
        const params = `?clientId=${clientId}&projectId=${projectId}`;
        const response = await getTagNames(fieldId, params);
        const tagValues = response.data.data.tagValues || [];
        const sortedTags = tagValues
          .slice()
          .filter((tag: ITag) => !tag.isDeleted)
          .sort((a: ITag, b: ITag) => b.displayOrder - a.displayOrder);
        return {...response.data.data, tagValues: sortedTags};
      } catch {
        // error intentionally ignored, handled via isFailedToLoadContent flag
        setState({isLoading: false, isFailedToLoadContent: true});
        return null;
      } finally {
        !state.isFailedToLoadContent &&
          setState((prevState) => ({...prevState, isLoading: false}));
      }
    },
    [clientId, projectId]
  );

  const resetErrorFlag = useCallback(() => {
    setState((prevState) => ({...prevState, isFailedToLoadContent: false}));
  }, [state.isFailedToLoadContent]);

  return {
    getAllTagNames,
    isLoading: state.isLoading,
    isFailedToLoadContent: state.isFailedToLoadContent,
    resetErrorFlag,
  };
};
